module.exports = __webpack_public_path__ + "img/no-image.6aabb4b3.png";